export const SPECTATOR_CHAT_WIDTH = 300;
